<template>
  <div class="user_cell before_border mt15">
    <div class="header after_border">
      <img v-lazy="clazzUser.user.avatar_url" class="headimg">
      <div class="username">
        {{ clazzUser.user.nickname }}
        <div v-if="isManager" style="padding-top: 2px; margin-left: 5px;">
          <a :href="'tel:' + clazzUser.user.mobile + '#mp.weixin.qq.com'"><van-icon name="phone-o" /></a>
        </div>
      </div>
      <div class="more" @click="onMore(clazzUser.user)">
        打卡日历
        <van-icon class="icon" name="arrow" />
      </div>
    </div>
    <div class="body after_border">
      <div class="item">
        <div class="label">加入时间</div>
        <div class="value">{{ clazzUser.add_time }}</div>
      </div>
      <div class="item">
        <div class="label">打卡天数</div>
        <div class="value">{{ clazzUser.days }}天</div>
      </div>
      <div class="item">
        <div class="label">打卡公里数</div>
        <div class="value">{{ clazzUser.distance }}公里</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant'

export default {
  name: 'UserCell',
  components: {
    [Icon.name]: Icon
  },
  props: {
    clazzUser: {
      type: Object
    },
    isManager: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      clazzId: undefined
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
  },
  methods: {
    onMore (user) {
      this.$router.push('/manage/clazz/' + this.clazzId + '/user/' + user.uuid + '/data')
    }
  }
}
</script>

<style scoped lang="scss">
.user_cell {
  padding-left: 20px;
  .header {
    height: 75px;
    display: flex;
    align-items: center;
    .headimg {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .username {
      margin-left: 15px;
      font-size: 32px;
      font-weight: bold;
      width: 515px;
      display: flex;
    }
    .more {
      display: flex;
      align-items: center;
      font-size: 28px;
      color: #969799;
      .icon {
        font-size: 32px;
      }
    }
  }
  .body {
    .item {
      padding-right: 20px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #969696;
      font-size: 28px;
    }
  }
}
</style>
